/* eslint-disable max-lines */
import { css } from 'linaria';
import { styled } from 'linaria/react';

const getBannerBackground = (size: string, variant: string, index: number) => {
  if (size === 'm') {
    return `background-image: url(https://cdn.lemanapro.ru/lmru/image/upload/v1725869886/fudzi/elbrus/images/landings/special-offer-block/${variant}/${variant}-m.jpg/${variant}-m-c.jpg);`;
  }

  return `background-image: url(https://cdn.lemanapro.ru/lmru/image/upload/v1725869886/fudzi/elbrus/images/landings/special-offer-block/${variant}/${variant}-${size}-${index}.jpg/${variant}-${size}-${index}-c.jpg);`;
};

export const getStandartBannerGrid = (variant: string, gridSize: number) => `
  [data-banner="content"] {
    ${getBannerBackground('ld', variant, gridSize)}
    
    @media (--only-desktop) {
      ${getBannerBackground('d', variant, gridSize)}
    }
      
    @media (--only-tablet) {
      ${getBannerBackground('t', variant, gridSize)}
    }
    
    @media (--only-mobile) {
      ${getBannerBackground('m', variant, gridSize)}
    }
  }
`;

export const getThreeBannerGrid = (variant: string) => `
  [data-banner="content"] {  
    ${getBannerBackground('ld', variant, 2)}
    
    @media (--only-desktop) {
      ${getBannerBackground('d', variant, 2)}
    }
      
    @media (--only-tablet) {
      ${getBannerBackground('t', variant, 2)}
    }
    
    @media (--only-mobile) {
      ${getBannerBackground('m', variant, 0)}
    }
  }

  @media (--only-large-desktop) {
    [data-banner-position="1"] {
      ${getBannerBackground('ld', variant, 1)}
    }
  }

  @media (--only-desktop) {
    [data-banner-position="1"] {
      ${getBannerBackground('d', variant, 1)}
    }
  }

  @media (--only-tablet) {
    [data-banner-position="1"] {
      ${getBannerBackground('t', variant, 1)}
    }
  }
`;

export const getFiveBannerGrid = (variant: string) => `
  [data-banner="content"] {  
    ${getBannerBackground('ld', variant, 2)}
    
    @media (--only-desktop) {
      ${getBannerBackground('d', variant, 2)}
    }
          
    @media (--only-tablet) {
      ${getBannerBackground('t', variant, 2)}
    }
    
    @media (--only-mobile) {
      ${getBannerBackground('m', variant, 0)}
    }
  }

  @media (--only-large-desktop) {
    [data-banner-position="1"] {
      ${getBannerBackground('ld', variant, 1)}
    }
  }
    
  @media (--only-desktop) {
    [data-banner-position="1"] {
      ${getBannerBackground('d', variant, 1)}
   }
  }

  @media (--only-tablet) {     
    [data-banner-position="1"] {
      ${getBannerBackground('t', variant, 1)}
    }
  }
`;

export const specialOfferGrid = css`
  display: grid;
  grid-template-rows: auto;
  gap: 24px 32px;

  @media (--only-large-desktop) {
    grid-template-columns: 574px 574px;

    [data-banner-content='only-text'] {
      font-size: 28px;
      line-height: 34px;
    }

    [data-banner-content='text'] {
      width: 320px;
    }
  }

  @media (--only-desktop) {
    grid-template-columns: 459px 459px;
    gap: 24px 22px;

    [data-banner='content'] {
      padding: 0 24px;
    }

    [data-banner-content='only-text'] {
      font-weight: 500;
      font-size: 26px;
      line-height: 32px;
    }

    [data-banner-content='text'] {
      width: 218px;
    }
  }

  @media (--only-tablet) {
    grid-template-columns: 321px 321px;
    gap: 16px 18px;

    [data-banner-content='only-text'] {
      font-weight: 500;
      font-size: 22px;
      line-height: 28px;
    }

    [data-banner-content='text'] {
      width: 137px;
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    gap: 16px;

    [data-banner='content'] {
      padding: 0 12px;
    }
  }
`;

export const specialOfferOddGrid = css`
  & > div:first-of-type {
    @media (--only-large-desktop) {
      [data-banner='content'] {
        column-gap: 40px;
      }
    }

    @media (--from-tablet) {
      grid-column: auto / span 2;

      [data-banner='content'] {
        padding: 0 32px;
      }

      [data-banner-content='discount-wrapper'] {
        width: 150px;
        margin-right: 16px;
      }

      [data-banner-add-content='discount-wrapper-minus'] {
        padding-left: 35px;
      }

      [data-banner-add-content='discount-wrapper-minus']::before {
        width: 30px;
      }

      [data-banner-content='only-text'] {
        font-weight: 700;
        font-size: 34px;
        line-height: 40px;
      }

      [data-banner-content='text'] {
        flex-grow: 1;
        width: auto;
        font-size: 20px;
        line-height: 26px;
      }

      [data-banner-content='prefix'] {
        top: 0;
        left: 3px;
        font-size: 20px;
        line-height: 26px;
      }

      [data-banner-content='discount'] {
        font-size: 48px;
        line-height: 56px;
      }

      [data-icons-pack='wrapper'] {
        width: 48px;
        height: 48px;
      }
    }
  }
`;

export const SpecialOfferBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 152px;

  padding: 0 20px;
  column-gap: 0;
  background-size: contain;
  border-radius: var(--rounding-m);
  cursor: pointer;

  @media (--to-desktop) {
    column-gap: 0;
  }

  @media (--only-tablet) {
    padding: 0 16px;
  }

  @media (--only-mobile) {
    height: 113px;
    padding: 0 12px;
    column-gap: 8px;
    background-size: cover;
  }
`;

export const specialOfferBannerVarianMap: Record<string, Record<number, string>> = {
  'brand-primary': {
    1: css`
      ${getStandartBannerGrid('brand-primary', 1)}
    `,
    2: css`
      ${getStandartBannerGrid('brand-primary', 2)}
    `,
    3: css`
      ${getThreeBannerGrid('brand-primary')}
    `,
    4: css`
      ${getStandartBannerGrid('brand-primary', 2)}
    `,
    5: css`
      ${getFiveBannerGrid('brand-primary')}
    `,
    6: css`
      ${getStandartBannerGrid('brand-primary', 2)}
    `,
  },
  'brand-secondary': {
    1: css`
      ${getStandartBannerGrid('brand-secondary', 1)}
    `,
    2: css`
      ${getStandartBannerGrid('brand-secondary', 2)}
    `,
    3: css`
      ${getThreeBannerGrid('brand-secondary')}
    `,
    4: css`
      ${getStandartBannerGrid('brand-secondary', 2)}
    `,
    5: css`
      ${getFiveBannerGrid('brand-secondary')}
    `,
    6: css`
      ${getStandartBannerGrid('brand-secondary', 2)}
    `,
  },
  'secondary-green-dark': {
    1: css`
      ${getStandartBannerGrid('secondary-green-dark', 1)}
    `,
    2: css`
      ${getStandartBannerGrid('secondary-green-dark', 2)}
    `,
    3: css`
      ${getThreeBannerGrid('secondary-green-dark')}
    `,
    4: css`
      ${getStandartBannerGrid('secondary-green-dark', 2)}
    `,
    5: css`
      ${getFiveBannerGrid('secondary-green-dark')}
    `,
    6: css`
      ${getStandartBannerGrid('secondary-green-dark', 2)}
    `,
  },
  'secondary-red-primary': {
    1: css`
      ${getStandartBannerGrid('secondary-red-primary', 1)}
    `,
    2: css`
      ${getStandartBannerGrid('secondary-red-primary', 2)}
    `,
    3: css`
      ${getThreeBannerGrid('secondary-red-primary')}
    `,
    4: css`
      ${getStandartBannerGrid('secondary-red-primary', 2)}
    `,
    5: css`
      ${getFiveBannerGrid('secondary-red-primary')}
    `,
    6: css`
      ${getStandartBannerGrid('secondary-red-primary', 2)}
    `,
  },
  'secondary-green-primary': {
    1: css`
      ${getStandartBannerGrid('secondary-green-primary', 1)}
    `,
    2: css`
      ${getStandartBannerGrid('secondary-green-primary', 2)}
    `,
    3: css`
      ${getThreeBannerGrid('secondary-green-primary')}
    `,
    4: css`
      ${getStandartBannerGrid('secondary-green-primary', 2)}
    `,
    5: css`
      ${getFiveBannerGrid('secondary-green-primary')}
    `,
    6: css`
      ${getStandartBannerGrid('secondary-green-primary', 2)}
    `,
  },
};

export const specialOfferBannerContentWrapper = css`
  display: flex;
  align-items: center;
  width: -webkit-fill-available;
`;

export const specialOfferBannerContentDiscount = css`
  width: 150px;
  margin-right: 16px;

  @media (--only-desktop) {
    width: 137px;
    margin-right: 8px;
  }

  @media (--only-tablet) {
    width: 120px;
    margin-right: 8px;
  }

  @media (--only-mobile) {
    width: 84px;
    margin-right: 6px;
  }
`;

export const specialOfferBannerAddContentDiscount = css`
  position: relative;
  padding-left: 35px;

  &&:before {
    position: absolute;
    top: 50%;
    left: 0;
    width: 30px;
    height: 5px;
    background-color: var(--text-primary);
    transform: translateY(-50%);
    content: '';
  }

  @media (--only-desktop) {
    padding-left: 32px;

    &&:before {
      width: 27px;
    }
  }

  @media (--only-tablet) {
    padding-left: 28px;

    &&:before {
      width: 20px;
    }
  }

  @media (--only-mobile) {
    padding-left: 20px;

    &&:before {
      width: 16px;
      height: 2px;
    }
  }
`;

export const specialOfferBannerWhiteAddContentDiscount = css`
  &&:before {
    background-color: var(--text-primary-invert);
  }
`;

export const specialOfferBannerContentDiscountPrefix = css`
  && {
    position: absolute;
    top: 0;
    left: 3px;
    line-height: 26px;

    @media (--only-tablet) {
      top: 6px;
      left: 2px;
      font-size: 14px;
      line-height: 20px;
    }

    @media (--only-mobile) {
      left: 2px;
      font-size: 10px;
      line-height: 16px;
    }
  }
`;

export const specialOfferBannerContentDiscountText = css`
  @media (--only-tablet) {
    font-size: 40px;
    line-height: 56px;
  }

  @media (--only-mobile) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const specialOfferBannerContentText = css`
  && {
    white-space: break-spaces;

    @media (--only-mobile) {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const specialOfferBannerContentTextWithDiscount = css`
  && {
    @media (--only-mobile) {
      width: 44.3vw;
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const specialOfferBannerChevronIcon = css`
  && {
    @media (--to-tablet) {
      width: 24px;
      height: 24px;
    }
  }
`;
